export function changeTheme(theme){
  return {
    type: "CHANGE_THEME",
    theme
  }
}